import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Button, Alert, App, Checkbox, } from 'antd';
import FormModal from 'components/FormModal';
import { shareProject } from 'api/project-api';
import { useSession } from 'components/Authenticated';
import { txt } from 'libs/i18n';
import UserSearchInput from './UserSearchInput';
import styles from './style.module.less';
const ProjectShareDialog = ({ projectsToShare, onClose, modalVisible, }) => {
    const { session } = useSession();
    const { notification, message } = App.useApp();
    const [shareWith, setShareWith] = useState({
        email: '',
        validity: 'unchecked',
    });
    const [isReadonly, setIsReadonly] = useState(false);
    const reportSharingResult = ({ total, success, failed, blocked, alreadyShared, }) => {
        if (blocked > 0) {
            // NOTE: If one was blocked, all were blocked
            notification.error({
                message: txt('sharingBlocked'),
                description: txt('sharingBlockedDescription'),
                placement: 'topRight',
                duration: 0,
            });
            return;
        }
        if (success === total) {
            void message.success(txt('sharingSuccessful'));
            return;
        }
        if (alreadyShared === total) {
            void message.info(txt('alreadyShared'));
            return;
        }
        if (failed === 0) {
            void message.success(txt('sharingSuccessful'));
            return;
        }
        notification.error({
            message: txt('failedToShare'),
            description: (_jsx("p", { children: `${txt('projShareCount')}: ${success + alreadyShared}/${total}` })),
            placement: 'topRight',
            duration: 0,
        });
    };
    const handleShare = async () => {
        const shareAsReadonly = session.login.hasClaim('share:readonly') && isReadonly;
        const resolved = await Promise.all(projectsToShare.map((proj) => (shareProject(session.connection, proj, shareWith.email, shareAsReadonly))));
        const finalResult = {
            total: resolved.length,
            success: 0,
            failed: 0,
            blocked: 0,
            alreadyShared: 0,
        };
        resolved.forEach((result) => {
            if (result.isSuccess()) {
                finalResult.success += 1;
                return;
            }
            if (result.err() === 'already-shared') {
                finalResult.alreadyShared += 1;
                return;
            }
            if (result.err() === 'invalid-email' || result.err() === 'cannot-share') {
                finalResult.blocked += 1;
                return;
            }
            finalResult.failed += 1;
        });
        reportSharingResult(finalResult);
        onClose(finalResult.success);
    };
    const handleShareOnEnter = () => {
        if (shareWith.validity === 'valid') {
            void handleShare();
        }
    };
    return (_jsxs(FormModal, { muteShortcuts: ['Tab', 'Shift+Tab'], className: styles.shareModal, title: txt('shareProjs'), open: modalVisible, onCancel: () => onClose(0), maskClosable: false, footer: [
            _jsx(Button, { onClick: () => onClose(0), children: txt('cancel') }, "cancel"),
            _jsx(Button, { type: "primary", disabled: shareWith.validity !== 'valid', onClick: handleShare, children: txt('share') }, "share"),
        ], children: [_jsxs("p", { children: [txt('projsToShare'), ": \u00A0", projectsToShare.length] }), _jsx(Alert, { type: "info", showIcon: true, message: txt('shareAlert') }), _jsx(UserSearchInput, { label: txt('shareWith'), value: shareWith, autoFocus: true, onChange: setShareWith, onPressEnter: handleShareOnEnter, projectsToShare: projectsToShare }), session.login.hasClaim('share:readonly') && (_jsx(Checkbox, { className: styles.readOnlyCheckbox, checked: isReadonly, onChange: (e) => setIsReadonly(e.target.checked), children: txt('shareAsReadOnly') }))] }));
};
export default ProjectShareDialog;
